import { ReactNode, useState } from "react";

import styles from "./HomeLayout.module.css";
import Aside from "./Aside";
import RightSidebar from "./RightSidebar";
import { useCompare } from "../../providers";

const HomeLayout = ({ children }: { children: ReactNode }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { isComparing } = useCompare();

  const wrapperClass = isComparing
    ? styles.contentWrapperCompare
    : isCollapsed
    ? styles.contentWrapperCollapsed
    : "";

  return (
    <div className={styles.container}>
      <div className={`${styles.contentWrapper} ${wrapperClass}`}>
        <Aside onCollapseChange={setIsCollapsed} forceCollapsed={isComparing} />
        <div className={`${styles.mainAndRightArea} ${isComparing ? styles.mainAreaCompare : ""}`}>
          {children}
          {!isComparing && <RightSidebar />}
        </div>
      </div>
    </div>
  );
};
export default HomeLayout;
